export const FETCH_DESPATCH_REQUEST = 'FETCH_DESPATCH_REQUEST';
export const FETCH_DESPATCH_SUCCESS = 'FETCH_DESPATCH_SUCCESS';
export const FETCH_DESPATCH_FAILURE = 'FETCH_DESPATCH_FAILURE';
